import React, {FC, useState} from 'react';
import ReactPaginate from 'react-paginate';
import {LeftArrowIcon, RightArrowIcon} from '../../ui-components/Iconpack';

export interface PaginationProps {
    pageCount: number;
    onPageChange: (selectedItem: {selected: number}) => void;
}

export const Pagination: FC<PaginationProps> = ({pageCount, onPageChange}) => {
    const [currentPage, setCurrentPage] = useState(0);

    const handlePageChange = (selectedItem: {selected: number}) => {
        setCurrentPage(selectedItem.selected);
        onPageChange(selectedItem);
    };

    return (
        <>
            {pageCount > 1 && (
                <ReactPaginate
                    className={
                        'mt-24 flex items-center justify-center gap-1 border-t-[1px] p-10 text-[16px] font-[600] text-gray-700'
                    }
                    breakLabel='...'
                    nextLabel={
                        <div className={'flex items-center justify-center gap-2'}>
                            Next <RightArrowIcon />
                        </div>
                    }
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={2}
                    pageCount={pageCount}
                    previousLabel={
                        <div className={'flex items-center justify-center gap-2'}>
                            <LeftArrowIcon /> Previous
                        </div>
                    }
                    containerClassName={'flex justify-center'}
                    activeClassName={'bg-[#4E5BA6] text-white rounded-[4px]'}
                    pageClassName={'p-2 px-4'}
                    nextClassName={`mx-6 ${currentPage === pageCount - 1 ? 'hidden' : 'flex'} `}
                    previousClassName={`mx-6 ${currentPage === 0 ? 'hidden' : 'flex'} `}
                />
            )}
        </>
    );
};
